import { SEO } from "@/components/SEO";
import { headTageTitle } from "@/utils/head-tag-title";
import { getConfigSSR } from "api/config";
import { useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { ConfigPage, NextPageWithLayoutAndPageType } from "types/index";

const AboutUsPage: NextPageWithLayoutAndPageType = (props: any) => {
  const storeConfig = useAppSelector((state) => state.config);
  const config = props.config || storeConfig;
  const siteTitleFromHeadTag = useMemo(() => headTageTitle(config), [config]);

  const siteName = siteTitleFromHeadTag
    ? siteTitleFromHeadTag
    : config.company_info?.name;
  const seoconfig = config.pages?.find(
    (page: ConfigPage) => page?.page_type === "about",
  )?.config;
  const description =
    seoconfig?.description ||
    `Learn more about ${siteName}. Discover our story, mission, and commitment to providing the best movie experience.`;
  const keywords = seoconfig?.keywords || [
    "about",
    "cinema history",
    "movie theater",
    siteName,
  ];
  const title = seoconfig?.title || "About Us";

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
    />
  );
};

AboutUsPage.page_type = "about";
export const getServerSideProps = getConfigSSR;

export default AboutUsPage;
